import { Box, Card, Flex, Heading, Text } from "@radix-ui/themes"
import type { PropsWithChildren } from "react"

import { ThemeProvider } from "@/components/theme-provider"

interface AuthLayoutProps {
  name?: string
  title?: string
  description?: string
  footer?: React.ReactNode
}

export default function CenteredLayout({
  children,
  title,
  description,
  footer,
}: PropsWithChildren<AuthLayoutProps>) {
  return (
    <ThemeProvider>
      <Flex align="center" justify="center" direction="column" gap="6" className="h-screen">
        <Card variant="classic" size="1">
          <Flex direction="column" gap="8" p="6" width="420px">
            <Flex direction="column" align="center" gap="4">
              <Box className="space-y-2 text-center">
                <Heading size="5">{title}</Heading>

                <Text size="2" color="gray" align="center">
                  {description}
                </Text>
              </Box>
            </Flex>

            {children}
          </Flex>
        </Card>

        {footer}
      </Flex>
    </ThemeProvider>
  )
}
